/* ============================================================
   ArabianShope  ·  scroll-in motion for the home page sections
   ------------------------------------------------------------
   One script for every custom section instead of a copy in each:
   when a section scrolls into view, its heading fades in and its
   cards rise one after another, left to right.

   Works with assets/custom.css ("SCROLL-IN MOTION" block), which
   holds the keyframes. Nothing is hidden until this script has
   run, so if it fails to load the page simply shows normally.

   Flash deals is included too; its tab script calls window.asStagger
   on the panel it reveals, so a tab switch re-runs this same rise.

   Respects the visitor's "reduce motion" setting: does nothing.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Things that rise in. One class per section, the section's own
     card / tile / banner element. Add a class here to include a
     new section; nothing else needs touching. */
  var CARDS = [
    '.fd-card',   /* Flash deals / Combo     */
    '.cc-card',   /* Category cards          */
    '.dc-card',   /* Deal cards              */
    '.tg-card',   /* Trending grid           */
    '.fg-card',   /* Featured grid           */
    '.fg-ban',    /* Featured grid banner    */
    '.pr-card',   /* Recommendations         */
    '.cs-card',   /* Collection shop         */
    '.tb-item',   /* Trust bar               */
    '.sp-band',   /* Split promo banner      */
    '.up-band',   /* UAE pride band          */
    '.ps-copy',   /* Spotlight banner: text  */
    '.ps-media',  /* Spotlight banner: image */
    '.ps-full',   /* Spotlight banner: full  */
    '.ps-benefit',/* Spotlight banner: list  */
    '.pd-card',   /* Promo banner pair       */
    '.bl-card'    /* Brand logos             */
  ].join(',');

  /* Things that just fade in, slightly ahead of the cards. */
  var HEADS = ['.fd-head', '.cc-head', '.dc-head', '.tg-head', '.fg-head', '.pr-head', '.cs-head', '.bl-head'].join(',');

  var STEP = 70;      /* ms between one card and the next */
  var MAX_STEP = 10;  /* after this many, the rest arrive together */

  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) return;

  function prime(section) {
    var cards = section.querySelectorAll(CARDS);
    var heads = section.querySelectorAll(HEADS);
    if (!cards.length && !heads.length) return false;
    for (var i = 0; i < cards.length; i++) cards[i].classList.add('as-wait');
    for (var h = 0; h < heads.length; h++) heads[h].classList.add('as-wait');
    return true;
  }

  function isShown(el) {
    /* skip pool cards that are not on screen and anything inside a hidden tab panel */
    return !el.hidden && !(el.closest && el.closest('[hidden]'));
  }

  /* Rise the visible cards in `container`, left to right. Also exposed as
     window.asStagger so a section with tabs can re-run it on the panel it
     reveals - same keyframes, same timing, so the whole page moves alike. */
  function stagger(container) {
    var cards = container.querySelectorAll(CARDS);
    var list = [];
    for (var i = 0; i < cards.length; i++) if (isShown(cards[i])) list.push(cards[i]);
    /* shuffled rows set style.order; animate in the order the eye reads them */
    list.sort(function (a, b) { return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0); });
    for (var d = 0; d < list.length; d++) {
      var el = list[d];
      el.classList.remove('as-in');
      void el.offsetWidth;                          /* restart if it already ran */
      el.style.animationDelay = (80 + Math.min(d, MAX_STEP) * STEP) + 'ms';
      el.classList.remove('as-wait');
      el.classList.add('as-in');
    }
  }
  window.asStagger = stagger;

  function reveal(section) {
    var heads = section.querySelectorAll(HEADS);
    for (var h = 0; h < heads.length; h++) {
      heads[h].style.animationDelay = '0ms';
      heads[h].classList.remove('as-wait');
      heads[h].classList.add('as-in');
    }
    stagger(section);
    /* anything still waiting (hidden pool cards, hidden tab panels) must not stay invisible */
    var left = section.querySelectorAll('.as-wait');
    for (var k = 0; k < left.length; k++) left[k].classList.remove('as-wait');
  }

  var io = new IntersectionObserver(function (entries) {
    for (var e = 0; e < entries.length; e++) {
      if (entries[e].isIntersecting) {
        reveal(entries[e].target);
        io.unobserve(entries[e].target);
      }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  for (var s = 0; s < sections.length; s++) {
    if (prime(sections[s])) io.observe(sections[s]);
  }

  /* Belt and braces: if something is still hidden 4s after load
     (an observer that never fired), show it. */
  setTimeout(function () {
    var stuck = document.querySelectorAll('.as-wait');
    for (var i = 0; i < stuck.length; i++) stuck[i].classList.remove('as-wait');
  }, 4000);
})();
